<script setup lang="ts">
import { useAuth } from "~/composables/auth/useAuth";
import { useEmailLogin } from "~/composables/auth/useEmailLogin";
import { useFetchProfile } from "~/composables/auth/useFetchProfile";
import { useGithubLogin } from "~/composables/auth/useGithubLogin";import { useGoogleLogin } from "~/composables/auth/useGoogleLogin";
;


definePageMeta({
  layout: "auth",
});

useSeoMeta({
  title: "Login",
});

const { user, loading: userLoading, fetchUserProfile } = useFetchProfile();
const { githubLogin, loading } = useGithubLogin();
const { googleLogin, loading: googleLoading } = useGoogleLogin();
const { emailLogin, loading: emailLoading, error: emailError } = useEmailLogin();
const { token } = useAuth();
const toast = useToast();
const fields = [
  {
    name: "email",
    type: "email",
    label: "Email",
    placeholder: "Enter your email",
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Enter your password",
  },
];

// const fields = [];

const validate = (state: any) => {
  const errors = [];
  if (!state.email) errors.push({ path: "email", message: "Email is required" });
  if (!state.password) errors.push({ path: "password", message: "Password is required" });
  return errors;
};


const providers = ref([
{
    label: "Sign in with Google",
    icon: "i-devicon-google",
    color: "black" as const,
    loading: googleLoading.value,
    click: async () => {
      await googleLogin();
    },
  },
  {
    label: "Sign in with GitHub",
    icon: "i-simple-icons-github",
    color: "black" as const,
    loading: loading.value,
    click: async () => {
      await githubLogin();
    },
  },
]);

async function onSubmit(data: { email: string, password: string }) {
  await emailLogin(data.email, data.password);
  if (emailError.value) {
    const err = "Invalid email / password";
    toast.add({
      title: err,
      color: "red",
    });
  }
}

watch(() => user.value?.id, () => {
  clear();
  if (!user.value?.id) return;
  navigateTo("/onboarding");
});

onMounted(async () => {
  clear();
  if (!token.value) return;
  await fetchUserProfile();
  navigateTo("/onboarding");
})

function clear() {
  const c = useRoute().query.clear === "true";
  if (c) {
    user.value = null;
  }
}

onBeforeMount(() => {
  clear()
})

</script>

<!-- eslint-disable vue/multiline-html-element-content-newline -->
<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
  <UCard class="max-w-sm w-full bg-white/75 dark:bg-white/5 backdrop-blur" v-if="!userLoading && !user?.id">
    <UAuthForm :fields="fields" :validate="validate" :providers="providers" title="Welcome back" align="bottom"
      ref="form" icon="i-heroicons-user-circle" :ui="{ base: 'text-center', footer: 'text-center' }"
      :submit-button="{ trailingIcon: 'i-heroicons-arrow-right-20-solid', loading: emailLoading }" @submit="onSubmit">
      <template #description>
        Don't have an account? <NuxtLink to="/signup" class="text-primary font-medium">Sign up</NuxtLink>.
      </template>

      <template #password-hint>
        <NuxtLink to="/forgot-password" class="text-primary font-medium">Forgot password?</NuxtLink>
      </template>

      <template #footer>
        By signing in, you agree to our <NuxtLink to="/" class="text-primary font-medium">Privacy Policy</NuxtLink> and
        <NuxtLink to="/" class="text-primary font-medium">Terms of Service</NuxtLink>.
      </template>
    </UAuthForm>
  </UCard>
</template>
